export default __webpack_public_path__ + "locales/it/BackupCodesDialog.json?hash=9b55a28fa90068cc53f379783b81c517";